<template>
  <OverlayLoader :visible="isLoading" />
  <div class="m-auto m-1230">
    <form style="max-width: 550px">
      <div class="card bg-white border-0 rounded-10 mb-4 text-center">
        <div class="card-body p-4">
          <div class="mb-3 mb-md-4">
            <img
              src="/favicon-32x32.png"
              class="rounded-3 for-light-logo"
              alt="login"
            />
          </div>
          <img
            src="@/assets/images/white-logo.svg"
            class="rounded-3 for-dark-logo"
            alt="login"
          />
          <h4 class="fs-20 fw-semibold mb-2">{{isSuccess?"Éxito":"Error"}} !</h4>
          <p class="mb-4">
            {{message}}
          </p>

          <RouterLink
            to="/login"
            class="btn btn-primary fs-16 fw-medium text-dark py-2 px-4 text-white w-100"
          >
            Ir Login
          </RouterLink>
        </div>
      </div>
    </form>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import OverlayLoader from "@/components/Others/OverlayLoader.vue";
import { useRoute } from "vue-router";
import api from "@/services/api";

export default defineComponent({
  name: "ConfirmMail",
  components: {
    OverlayLoader,
  },
  setup() {
    const route = useRoute();
    const isLoading = ref(false);
    const isSuccess = ref(false);
    const message = ref("");

    onMounted(async () => {
      try {
        var key = route.query.key;
        if (key) {
          await getValidateChangeUsername(key);
        } else {
          isSuccess.value = false;
          message.value = "El link de verificación no es válido";
        }
      } catch (error) {
        isSuccess.value = false;
        message.value = "El link de verificación no es válido";
      }
    });

    const getValidateChangeUsername = async (key: any) => {
      try {
        isLoading.value = true;
        const response = await api.get(
          `/user/validate-changeusername?key=${key}`
        );
        if (response.data === "") {
          message.value = "Correo confirmado exitosamente.";
          isSuccess.value = true;
        } else {
          message.value = response.data;
          isSuccess.value = false;
        }
        isLoading.value = false;
      } catch (ex) {
        isSuccess.value = false;
        message.value = "El link de verificación no es válido";
      } finally {
        isLoading.value = false;
      }
    };
    return {
      isLoading,
      OverlayLoader,
      isSuccess,
      message,
    };
  },
});
</script>
